import { categories, regionOptions } from "@/mocks/site";
import type { Drama } from "@/mocks/dramas";

export function categoryLabel(key: string): string {
  const found = categories.find((item) => item.key === key);
  return found ? found.label : "全部短剧";
}

export function regionLabel(key: string): string {
  const found = regionOptions.find((item) => item.key === key);
  return found ? found.label : "内地";
}

export function episodeLabel(drama: Drama): string {
  if (drama.status === "已完结") return `${drama.episodes}集全`;
  return `更新至${drama.updatedEpisode}集`;
}

export function getDramaById(id: string | undefined, list: Drama[]): Drama | undefined {
  if (!id) return undefined;
  return list.find((item) => item.id === id);
}

export function relatedDramas(drama: Drama, list: Drama[], limit = 8): Drama[] {
  const sameCategory = list.filter((item) => item.id !== drama.id && item.category === drama.category);
  const others = list.filter((item) => item.id !== drama.id && item.category !== drama.category);
  return [...sameCategory, ...others].slice(0, limit);
}

export function filterDramas(
  list: Drama[],
  options: { type?: string; region?: string; year?: string; status?: string; q?: string }
): Drama[] {
  const keyword = (options.q || "").trim();
  return list.filter((item) => {
    if (options.type && options.type !== "all" && item.category !== options.type) return false;
    if (options.region && options.region !== "all" && item.region !== options.region) return false;
    if (options.year && options.year !== "all" && item.year !== options.year) return false;
    if (options.status === "ongoing" && item.status !== "连载中") return false;
    if (options.status === "done" && item.status !== "已完结") return false;
    if (keyword) {
      const haystack = `${item.title} ${item.tags.join(" ")} ${item.cast.join(" ")} ${item.director}`;
      if (!haystack.includes(keyword)) return false;
    }
    return true;
  });
}

export function sortDramas(list: Drama[], sort: string): Drama[] {
  const copy = [...list];
  if (sort === "hot") return copy.sort((a, b) => b.viewsNumber - a.viewsNumber);
  if (sort === "rating") return copy.sort((a, b) => b.rating - a.rating);
  return copy.sort((a, b) => (a.publishedAt < b.publishedAt ? 1 : -1));
}

export function rankBadge(index: number): string {
  if (index === 0) return "NO.1";
  if (index === 1) return "NO.2";
  if (index === 2) return "NO.3";
  return `NO.${index + 1}`;
}